import React from "react";

const APropos=()=>{

    return(
        <section className="content-page">
            <div className="content-page__intro">
                <p className="mono-label">A propos</p>
                <h1 className="art-title neon-title">NAAT</h1>
                <p className="text-muted">
                    Un univers entre peinture, photo, art digital et culture urbaine.
                </p>
            </div>

            <div className="surface-panel content-page__panel">
                <p>
                    Le travail de l'artiste explore la rencontre entre image capturee et geste pictural.
                    La bombe aerosol, l'acrylique et le dessin numerique deviennent des moyens de transformer
                    une scene, un portrait ou une ambiance en composition vivante.
                </p>
                <p>
                    Le site rassemble des oeuvres originales, des experimentations digitales et des pieces
                    construites autour d'une energie urbaine forte.
                </p>
            </div>
        </section>
    )
}

export default APropos
